import React from 'react';
import { CYoutubeURL, CKakaoTalkURL, CInstagramURL } from 'constants/base.const';
import { Avatar } from 'antd';
import InstagramSource from 'assets/icons/instagram.svg';
import KakaoSource from 'assets/icons/kakao-talk.svg';
import YoutubeSource from 'assets/images/logos/youtube.webp';

const SNSLinkedIconGroup = () => {
  return (
    <div className='small-logo'>
      <a href={CInstagramURL} target='_blank' rel='noopener noreferrer'>
        <Avatar style={{ marginRight: '15px' }} shape='square' src={InstagramSource} />
      </a>
      <a href={CKakaoTalkURL} target='_blank' rel='noopener noreferrer'>
        <Avatar style={{ marginRight: '15px' }} shape='square' src={KakaoSource} />
      </a>
      <a href={CYoutubeURL} target='_blank' rel='noopener noreferrer'>
        <img style={{ width: '20px' }} alt='youtube' src={YoutubeSource} />
      </a>
    </div>
  );
};

export default SNSLinkedIconGroup;
